export const fmtTRY = (kurus, currency = "TRY") => {
  const v = (kurus || 0) / 100;
  try {
    return new Intl.NumberFormat("tr-TR", { style: "currency", currency, maximumFractionDigits: 2 }).format(v);
  } catch {
    return `${v.toFixed(2)} ₺`;
  }
};

export const fmtGold = (mg) => {
  const g = (mg || 0) / 1000;
  if (g >= 1) return `${g.toFixed(g >= 10 ? 1 : 2)} gr`;
  return `${mg} mg`;
};

export const fmtDate = (iso, locale = "tr-TR") => {
  try {
    return new Date(iso).toLocaleString(locale, { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso || "";
  }
};

export const shortId = (s = "") => (s || "").slice(-6).toUpperCase();
